import { render, staticRenderFns } from "./RegisterSuccess.vue?vue&type=template&id=f7be8996&scoped=true&"
import script from "./RegisterSuccess.vue?vue&type=script&lang=ts&"
export * from "./RegisterSuccess.vue?vue&type=script&lang=ts&"
import style0 from "./RegisterSuccess.vue?vue&type=style&index=0&id=f7be8996&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7be8996",
  null
  
)

export default component.exports